// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientClosedItem_container__1Id4e","icon":"ClientClosedItem_icon__28zTk"};